import React from 'react'
// import SubHeader from '../general/SubHeader'
import AboutImg from '../assets/about-img.jpg';
import President from '../assets/president.png';
import Principal from '../assets/principal.jpg';
import ScrollAnimation from 'react-animate-on-scroll';
// import Course1 from '../assets/course1.jpg';
// import Course2 from '../assets/course2.jpg';
// import Course3 from '../assets/course3.jpg';
// import Course4 from '../assets/course6.jpg';


const About = () => {
  return (
    <>
      {/* <SubHeader message="About Us" /> */}
      {/* safely-measures */}
      <ScrollAnimation animateIn='fadeInUp'>
      <div className='safely-measures1'>
      <h2 >OUR SCHOOL</h2>
        <p>"KC Public School is dedicated to providing quality education in a nurturing environment. We focus on academic excellence,<br></br> character building, and holistic development, empowering students with knowledge, skills, and values<br></br> to thrive in an ever-changing world."</p>
       
      </div>
      </ScrollAnimation>
      {/*end safely-measures */}


      {/* Courses section */}
      {/* <section className='py-5 course-sec'>
        <div className='container text-center'>

          <p className='about-heading'>Our Courses</p>

          <div className='row'>

            <div class="col-lg-3 my-2 ">
              <div class="course-area">
                <img src={Course1} class="course-img" alt="..." />
                <h6 class="text-muted my-3" ><b> Foundational Stage<br />(Pre-Primary (LKG, UKG), Grade I to II)</b></h6>
              </div>
            </div>
            <div class="col-lg-3 my-2 ">
              <div class="course-area">
                <img src={Course4} class="course-img" alt="..." />
                <h6 class="text-muted my-3" ><b>Preparatory Stage<br />(Grade III to V)</b></h6>
              </div>
            </div>
            <div class="col-lg-3 my-2 ">
              <div class="course-area">
                <img src={Course3} class="course-img" alt="..." />
                <h6 class="text-muted my-3" ><b>Middle Stage <br />(Grade VI & VIII)</b></h6>
              </div>
            </div>
            <div class="col-lg-3 my-2 ">
              <div class="course-area">
                <img src={Course2} class="course-img" alt="..." />
                <h6 class="text-muted my-3" ><b>Secondary Stage<br />(Grade IX & XII)</b></h6>
              </div>
            </div>


          </div>

        </div>
      </section> */}
      {/* Courses section ends */}




      {/* 4-cards */}
      <div className='main-section'>
        <div className='first-section'>
          <div className='image-section'>
            <img src={Principal} alt='' />
          </div>
          <div className='description-section'>
            <h3>Principal's Desk</h3>
            <ScrollAnimation animateIn='fadeInUp'>
              <p><i class="fa-solid fa-caret-right me-2"></i>Education is to be enjoyed and imbibed in life
                and is the best route to improve the world in which we live. KCPS is always in its effort to provide its students safe,
                nurturing environment where faculty and staff “go the extra mile” to meet their needs.<br /><hr />
                <i class="fa-solid fa-caret-right me-2"></i>Apart from inspiring students to achieve the best possible academic
                results they are encouraged to acquire habits of curiosity, mental flexibility, self-discipline and maintain openness
                of mind, dignity of conduct and mutual respect in the background of social, cultural and linguistic diversity.<br /><hr />
                <i class="fa-solid fa-caret-right me-2"></i>No matter how long students stay with us, we have our efforts in shaping their lives by developing a confident understanding of their role in society.</p>
            </ScrollAnimation>
          </div>
        </div>
        <div className='second-section'>
          <div className='description-section'>
            <h3>President's Desk</h3>
            <ScrollAnimation animateIn='fadeInUp'>
              <p ><i class="fa-solid fa-caret-right me-2"></i>In today’s transcending times, education is a quintessential and highly challenging time for
                students. Guided by esteemed members and a group of talented as well as dedicated teachers KCPS works towards
                preparing its students to achieve very high standards in both the formal curriculum and in many extra-curricular
                activities.<br /><hr /><i class="fa-solid fa-caret-right me-2"></i>We hope that their involvement in and enjoyment of both work and play will help them to become enterprising young people ready to make their contribution in the years ahead.</p>
            </ScrollAnimation>
          </div>
          <div className='image-section'>
            <img src={President} alt='president' />
          </div>
        </div>
      </div>
      {/*end 4-cards */}







      {/* <section className='my-5'>
        <div className='container'> */}
          {/* <p className='text-muted'>The school was established in the year 1984 by the sincere and dynamic efforts of Smt. V. Sugnana Kumari Deo, President, K. C. Trust Managing Committee. K. C. Trust is a non-profit, educational body widely recognized for its commitment to excellence in education. Education leadership and scholarly achievement is its mission. Strong in tradition it has evolved as a matrix among the educational institutions in the district of Ganjam, Odisha.</p>
            <p className='fs-5 fw-semibold'>Look  ing Forward</p>
            <p className='text-muted'>K. C. Trust has contributed to the society in the form of many successful professionals and wholesome citizens. As part of our future endeavours, we look forward to guiding our students down the exemplary path that many previous Dipsites all around have walked on. The future generations are in our hands, and we eagerly await the challenge of training them to not only reason in terms of traditional disciplines, but also in developing the ability to use this training in creative thinking and problem-solving that in most instances tends to merge understanding from a number of different perspectives. Our visualization for tomorrow is learners who have acknowledged the potential of the advancement and diffusion of knowledge as the only guardian of the future – a tool which will assist them in shaping their tomorrow into a blissful merger or ethics, responsibility, courage, sensibilities and success.</p> */}
          {/*         
        <div class="row">
          <div class="col-lg-6 shadow p-3 mb-5" id="staying_ahead">
            <h3>STAYING AHEAD OF TECHNOLOGY</h3>
            <p>The technology age has made its way into our classrooms as well. It’s the time where students relate more to computers and tabs than to textbooks! KCPS is well equipped with Teach-Next and HCL classrooms and a spacious computer lab, audio-visual equipment, and CD-writers which aid to computer education. Our computer networking system has also made it easy for us to communicate important messages to parents via the SMS server. The ERP software assists us in school management programs.</p>
          </div>
          <div class="col-lg-6 shadow p-3 mb-5" id="looking_forward">
            <h3>LOOKING FORWARD</h3>
          </div>
        </div> */}
        {/* </div>
      </section> */}


      {/* counter section */}
      <ScrollAnimation className='my-5' animateIn='fadeInUp'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='d-flex'>
                <span className=' align-content-center me-3 text-primary'><i class="fa-solid fa-earth-asia fs-1"></i></span>
                <p className='counter-text'><span className='counter-num'>90 +</span><br />Full Time Faculty</p>
              </div>
            </div>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='d-flex'>
                <span className=' align-content-center me-3 text-primary'><i class="fa-solid fa-school fs-1"></i></span>
                <p className='counter-text'><span className='counter-num'>1:8</span><br />Student/ Teacher Ratio</p>
              </div>
            </div>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='d-flex'>
                <span className=' align-content-center me-3 text-primary'><i class="fa-solid fa-graduation-cap fs-1"></i></span>
                <p className='counter-text'><span className='counter-num'>85 %</span><br />Master Degrees</p>
              </div>
            </div>

            <div className='col-lg-3 col-md-6 col-12 my-2'>
              <div className='d-flex'>
                <span className=' align-content-center me-3 text-primary'><i class="fa-solid fa-building-columns fs-1"></i></span>
                <p className='counter-text'><span className='counter-num'>41 +</span><br />Years Established</p>
              </div>
            </div>


          </div>
          {/* row ends */}

        </div>
      </ScrollAnimation>
      {/* counter section ends */}


      <section className='my-5 px-3'>
        <div className='container about-outer'>

          <div className='row'>

            <div className='col-lg-6 col-12 px-0'>
              <img src={AboutImg} alt='' className='img-fluid' />
            </div>


            <div className='col-lg-6 col-12 py-4 px-4'>
              <p className='fw-semibold'><i class="fa-solid fa-caret-right me-2"></i> Staying Ahead of Technology</p>
              <hr />
              <p><i class="fa-solid fa-caret-right me-2"></i> The technology age has made its way into our classrooms as well. It’s the time where students relate more to
                computers and tabs than to textbooks!<br /><hr />
                <i class="fa-solid fa-caret-right me-2"></i> KCPS is well equipped with Teach-Next and HCL classrooms and a spacious computer lab, audio-visual equipment, and
                CD-writers which aid to computer education.<br /><hr />
                <i class="fa-solid fa-caret-right me-2"></i> Our computer networking system has also made it easy for us to communicate important messages to parents via
                the SMS server.<br /><hr />
                <i class="fa-solid fa-caret-right me-2"></i> The ERP software assists us in school management programs.<hr /></p>
            </div>

          </div>
          {/* row ends */}

        </div>
      </section>


      {/* messages section */}
      {/* <section className='py-5 bg-light'>
        <div className='container'>

          <p className='about-heading'>Messages</p>

          <ScrollAnimation animateIn='fadeInUp' className='row'>

            <div className='col-lg-6 col-12 my-2'>
              <img src={President} alt='' className='about-img' />
              <hr className='slider-hr' />
              <p className='fs-5 fw-semibold mt-3'>President's Desk</p>
              <p className='text-muted'><i class="fa-solid fa-caret-right me-2"></i>In today’s transcending times, education is a quintessential and highly challenging time for
                students. Guided by esteemed members and a group of talented as well as dedicated teachers KCPS works towards
                preparing its students to achieve very high standards in both the formal curriculum and in many extra-curricular
                activities.<br /><hr /><i class="fa-solid fa-caret-right me-2"></i>We hope that their involvement in and enjoyment of both work and play will help them to become enterprising young people ready to make their contribution in the years ahead.</p>
            </div>

            <div className='col-lg-6 col-12 my-2'>
              <img src={Principal} alt='' className='about-img' />
              <hr className='slider-hr' />
              <p className='fs-5 fw-semibold mt-3'>Principal's Desk</p>
              <p className='text-muted'><i class="fa-solid fa-caret-right me-2"></i>Education is to be enjoyed and imbibed in life
                and is the best route to improve the world in which we live. KCPS is always in its effort to provide its students safe,
                nurturing environment where faculty and staff “go the extra mile” to meet their needs.<br /><hr />
                <i class="fa-solid fa-caret-right me-2"></i>Apart from inspiring students to achieve the best possible academic
                results they are encouraged to acquire habits of curiosity, mental flexibility, self-discipline and maintain openness
                of mind, dignity of conduct and mutual respect in the background of social, cultural and linguistic diversity.<br /><hr />
                <i class="fa-solid fa-caret-right me-2"></i>No matter how long students stay with us, we have our efforts in shaping their lives by developing a confident understanding of their role in society.</p>
            </div>


          </ScrollAnimation> */}
      {/* row ends */}

      {/* </div> */}
      {/* </section> */}

      {/* messages section ends */}

    </>
  )
}

export default About
